import { child, update, remove, onValue } from 'firebase/database'
import { proxy } from 'valtio'
import { pickBy } from 'lodash-es'

import * as firebaseConnection from '../firebaseConnection'

const ROOT_NODE = 'muteStates'

export const mutingState = proxy<{
  isMuted: boolean
  initiatedBy: number | null
  isPlaybackMuted: boolean
}>({
  isMuted: false,
  initiatedBy: null,
  isPlaybackMuted: false,
})

// Subscribe
firebaseConnection.runWhenReady((connection) => {
  // Adds a Firebase listener to track changes related to muted participants.
  onValue(
    child(child(connection.room, ROOT_NODE), `${connection.participantId}`),
    (snapshot) => {
      const mutingIntention = snapshot.val()

      if (mutingIntention) {
        mutingState.isMuted = mutingIntention.isMuted
        mutingState.initiatedBy = mutingIntention.initiatedBy
        mutingState.isPlaybackMuted = mutingIntention.isPlaybackMuted
      }
    }
  )
})

// Actions

const setMutingIntention = async ({
  participantId,
  isMuted,
  initiatorId,
  isPlaybackMuted,
}: {
  participantId: number
  initiatorId?: number
  isMuted?: boolean
  isPlaybackMuted?: boolean
}) => {
  const connection = await firebaseConnection.get()

  const data = {
    isMuted,
    isPlaybackMuted,
    initiatedBy: initiatorId || connection.participantId,
    lastUpdated: Date.now(),
  }

  // remove undefined values from the payload
  const payload = pickBy(data, (value) => value !== undefined)

  return update(
    child(child(connection.room, ROOT_NODE), `${participantId}`),
    payload
  ).catch((err: Error) => {
    connection.logError('SET_MUTE_STATE', 'Could not mute audio/video', err)
  })
}

/**
 * Clears the muting intention for a participant.
 * @param participantId - The ID of the participant.
 */
const clearMutingIntention = async (participantId: number): Promise<void> => {
  const connection = await firebaseConnection.get()

  try {
    await remove(child(child(connection.room, ROOT_NODE), `${participantId}`))
  } catch (err) {
    connection.logError(
      'CLEAR_MUTING_INTENTION',
      'Could not remove participant muting state',
      err
    )
  }
}

export { clearMutingIntention, setMutingIntention }
